import React from 'react';
import { DjayIllustrationProps } from '../types';
import { DjayIllustrationBase } from '../DjayIllustrationBase';
import { DjaySpecimen } from '../../DjaySpecimen';
export function UnstoppableIllustration({
  achievementId,
  variant = 'default',
  isUnlocked,
  rarity,
  size = 'md',
  animate = true,
  className = ''
}: DjayIllustrationProps) {
  return <DjayIllustrationBase isUnlocked={isUnlocked} rarity={rarity} size={size} className={className} data-id="element-3991">
      <div className="relative w-full h-full bg-gradient-to-b from-slate-900 to-indigo-900 overflow-hidden" data-id="element-3992">
        {/* Background: Night sky and stars */}
        <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3993">
          {/* Moon/Planet */}
          <circle cx="160" cy="40" r="25" fill="#E2E8F0" fillOpacity="0.2" data-id="element-3994" />
          <circle cx="165" cy="35" r="20" fill="#F8FAFC" fillOpacity="0.3" data-id="element-3995" />

          {/* Stars */}
          <path d="M30 40 L32 48 L40 50 L32 52 L30 60 L28 52 L20 50 L28 48 Z" fill="#FDE047" data-id="element-3996" />
          <path d="M150 120 L151 124 L155 125 L151 126 L150 130 L149 126 L145 125 L149 124 Z" fill="#FEF08A" data-id="element-3997" />
          <circle cx="80" cy="30" r="1.5" fill="white" data-id="element-3998" />
          <circle cx="40" cy="140" r="2" fill="white" data-id="element-3999" />
          <circle cx="180" cy="90" r="1" fill="white" data-id="element-4000" />
          <circle cx="120" cy="160" r="1.5" fill="white" data-id="element-4001" />
        </svg>

        {/* Djay */}
        <div className="absolute inset-0 z-10 flex items-center justify-center pt-[5%]" data-id="element-4002">
          <div className="w-[65%] h-[65%] flex items-center justify-center" data-id="element-4003">
            <DjaySpecimen look={{
            variant,
            accessory: 'doubleFlameCrown'
          }} size="hero" emotion={isUnlocked ? 'proud' : 'thinking'} animate={animate && isUnlocked} className="w-full h-full" data-id="element-4004" />
          </div>
        </div>

        {/* Foreground: Cape/Wind effect */}
        {isUnlocked && <svg className="absolute inset-0 w-full h-full z-0 pointer-events-none" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-4005">
            {/* Hero Cape behind Djay */}
            <path d="M70 90 Q40 120 20 180 Q80 160 130 180 Q160 120 130 90 Z" fill="#EF4444" opacity="0.9" data-id="element-4006" />
            <path d="M75 90 Q50 120 30 170 Q80 155 120 170 Q150 120 125 90 Z" fill="#DC2626" data-id="element-4007" />

            {/* Wind lines */}
            <path d="M10 100 Q40 90 60 100" stroke="white" strokeWidth="2" strokeLinecap="round" opacity="0.3" data-id="element-4008" />
            <path d="M140 120 Q170 110 190 120" stroke="white" strokeWidth="2" strokeLinecap="round" opacity="0.3" data-id="element-4009" />
          </svg>}
      </div>
    </DjayIllustrationBase>;
}